<div class="report-container">
  <div class="report-header">
    <div class="title-section">
      <h2 class="modern-title">Sales Tax Liability</h2>
      <p class="modern-subtitle">Track your collected and remitted taxes</p>
    </div>

    <div class="controls-section">
      <div class="btn-group modern-btn-group">
        @for (p of periods; track p) {
          <button
            class="btn modern-filter-btn"
            [class.active]="period === p"
            (click)="setPeriod(p)">
            {{ p }}
          </button>
        }
      </div>

      @if (period === 'Custom') {
        <div class="custom-date-section ms-3 d-flex align-items-center">
          <input type="date" [(ngModel)]="startDate" class="date-input">
          <span class="mx-2" style="color: white">to</span>
          <input type="date" [(ngModel)]="endDate" class="date-input">
          <button class="btn modern-action-btn primary-btn ms-2" (click)="applyCustomRange()">Apply</button>
        </div>
      }

      <button class="btn modern-action-btn primary-btn ms-3" (click)="exportPdf()">
        Export PDF
      </button>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-cards">
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Gross Sales</div>
        <div class="card-value text-gross">{{ totalGrossSales | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Non-Taxable Sales</div>
        <div class="card-value text-exempt">{{ totalNonTaxable | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Taxable Sales</div>
        <div class="card-value text-taxable">{{ totalTaxable | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card highlight-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Total Tax Collected</div>
        <div class="card-value text-tax">{{ totalTaxCollected | currency }}</div>
      </div>
    </div>
  </div>

  <!-- Chart Section (Middle) -->
  <div class="chart-section glass-card mt-4">
    <div class="section-header d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <h3 class="section-title text-white mb-0">Tax Collection Trend</h3>
        <span class="ms-2 period-tag">{{ period }}</span>
      </div>
      <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle tax collection chart" title="Toggle tax collection chart" (click)="isChartCollapsed = !isChartCollapsed"></button>
    </div>
    <div [collapse]="isChartCollapsed" [isAnimated]="true">
      <div class="chart-wrapper">
        <div class="row h-100 g-0">
          <div class="col-md-8 border-end border-white border-opacity-10 d-flex justify-content-center">
            @if (chartOptions) {
              <ag-charts [options]="chartOptions" style="height: 100%; width: 100%;"></ag-charts>
            }
          </div>
          <div class="col-md-4 d-flex justify-content-center">
            @if (taxabilityOptions) {
              <ag-charts [options]="taxabilityOptions" style="height: 100%; width: 100%;"></ag-charts>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detailed Breakdown Table (Bottom) -->
  <div class="breakdown-card glass-card mt-4 mb-4">
    <div class="section-header d-flex justify-content-between align-items-center mb-3"
      (click)="isBreakdownCollapsed = !isBreakdownCollapsed"
      style="cursor: pointer">
      <div class="d-flex align-items-center">
        <h3 class="section-title text-white mb-0">Tax Breakdown by Jurisdiction</h3>
        <span class="ms-2 period-tag">{{ period }}</span>
      </div>
      <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle tax breakdown" title="Toggle tax breakdown"></button>
    </div>

    <div [collapse]="isBreakdownCollapsed" [isAnimated]="true">
      <div class="table-responsive">
        <table class="table modern-table table-hover">
          <thead>
            <tr>
              <th class="text-white border-bottom border-secondary">Jurisdiction</th>
              <th class="text-white border-bottom border-secondary text-center">Tax Rate</th>
              <th class="text-white border-bottom border-secondary text-end">Gross Sales</th>
              <th class="text-white border-bottom border-secondary text-end">Non-Taxable</th>
              <th class="text-white border-bottom border-secondary text-end">Taxable Sales</th>
              <th class="text-white border-bottom border-secondary text-end">Tax Collected</th>
            </tr>
          </thead>
          <tbody>
            @for (row of taxJurisdictions; track row) {
              <tr>
                <td style="color: white">{{ row.name }}</td>
                <td class="text-center" style="color: white">{{ row.rate | number:'1.2-2' }}%</td>
                <td class="text-end" style="color: white">{{ row.grossSales | currency }}</td>
                <td class="text-end" style="color: rgba(255, 255, 255, 0.5)">{{ row.nonTaxable | currency }}</td>
                <td class="text-end" style="color: white">{{ row.taxable | currency }}</td>
                <td class="text-end fw-medium text-tax">{{ row.taxCollected | currency }}</td>
              </tr>
            }
            <!-- Totals Row -->
            <tr class="table-active">
              <td class="fw-medium text-white border-top border-secondary">TOTAL</td>
              <td class="border-top border-secondary"></td>
              <td class="text-end fw-medium text-white border-top border-secondary">{{ totalGrossSales | currency }}</td>
              <td class="text-end fw-medium text-white border-top border-secondary">{{ totalNonTaxable | currency }}</td>
              <td class="text-end fw-medium text-white border-top border-secondary">{{ totalTaxable | currency }}</td>
              <td class="text-end fw-medium text-tax border-top border-secondary">{{ totalTaxCollected | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>
